export const news = [
  {
    id: 'news-fengqi-premiere',
    title: '《风起长街》开播即登顶热搜，夏目彩春古装造型获一致好评',
    category: '作品更新',
    date: '2025-09-28',
    author: '编辑部',
    summary: '古装权谋剧《风起长街》正式开播，首播当晚即登顶多个平台热搜榜，夏目彩春饰演的沈清歌成为观众讨论焦点。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20an%20elegant%20asian%20woman%20in%20flowing%20red%20traditional%20robes%20standing%20in%20an%20ancient%20lantern%20lit%20street%20at%20dusk%2C%20wind%20lifting%20her%20sleeves%2C%20deep%20crimson%20and%20warm%20gold%20tones%2C%20dramatic%20cinematic%20lighting%2C%20editorial%20photography%2C%20film%20grain&width=800&height=560&seq=natsume-news-01&orientation=landscape',
    content: [
      { type: 'paragraph', text: '由小林志郎执导的古装权谋剧《风起长街》于本周正式开播，首播当晚即登上多个平台热搜榜首，相关话题阅读量迅速突破两亿。' },
      { type: 'heading', text: '沈清歌一角引发热议' },
      { type: 'paragraph', text: '夏目彩春在剧中饰演商贾之女沈清歌，从街头算账到踏入朝堂，角色层次丰富。首播集中，她以一场不动声色的谈判戏征服了大量观众。' },
      { type: 'paragraph', text: '不少观众在社交平台留言表示，夏目彩春的古装造型兼具英气与柔美，眼神戏尤为出色，「一个眼神就演出了三页台词的信息量」。' },
      { type: 'heading', text: '制作水准备受肯定' },
      { type: 'paragraph', text: '该剧的美术、服装与场景搭建均获得专业评价，被媒体称为「近年最具质感的历史题材作品之一」。剧组透露，为还原时代背景，仅服装就制作了超过三百套。' },
      { type: 'paragraph', text: '《风起长街》全剧共二十四集，后续剧情将围绕朝堂博弈与江湖纷争双线展开。' },
    ],
  },
  {
    id: 'news-wusheng-award',
    title: '《无声告白》入围国际电影节主竞赛单元，夏目彩春获最佳女主角提名',
    category: '新闻报道',
    date: '2025-09-15',
    author: '记者 陈默',
    summary: '电影《无声告白》成功入围某国际电影节主竞赛单元，夏目彩春凭借无台词表演获得最佳女主角提名。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20an%20asian%20woman%20in%20an%20elegant%20dark%20gown%20standing%20on%20a%20red%20carpet%20at%20night%20surrounded%20by%20soft%20photographer%20flashes%2C%20moody%20warm%20gold%20and%20deep%20charcoal%20tones%2C%20editorial%20photography%2C%20film%20grain&width=800&height=560&seq=natsume-news-02&orientation=landscape',
    content: [
      { type: 'paragraph', text: '备受关注的悬疑剧情片《无声告白》确认入围某国际电影节主竞赛单元，这也是夏目彩春首次以主演身份进入国际A类电影节视野。' },
      { type: 'heading', text: '无台词表演获专业认可' },
      { type: 'paragraph', text: '在片中，夏目彩春饰演一名聋哑女子，全片几乎没有台词。评委会在入围评语中特别提到，她「用身体与眼神完成了几乎不可能的叙事」。' },
      { type: 'paragraph', text: '为贴近角色，夏目彩春在开拍前系统学习了数月手语，并与听障人士共同生活以观察细节。' },
      { type: 'heading', text: '业内普遍看好' },
      { type: 'paragraph', text: '多位影评人认为，该角色有望冲击年度最佳女主角奖项。影片将于下月正式公映。' },
    ],
  },
  {
    id: 'news-fanmeeting',
    title: '夏目彩春巡回粉丝见面会官宣，首站定于东京',
    category: '活动信息',
    date: '2025-08-30',
    author: '活动组',
    summary: '官方正式公布夏目彩春年度巡回粉丝见面会计划，首站将于十月在东京举行，共设五个城市站点。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20a%20large%20warm%20lit%20fan%20event%20stage%20with%20glowing%20amber%20and%20red%20lights%2C%20blurred%20crowd%20silhouettes%20in%20the%20foreground%2C%20cinematic%20atmospheric%20lighting%2C%20editorial%20photography%2C%20film%20grain&width=800&height=560&seq=natsume-news-03&orientation=landscape',
    content: [
      { type: 'paragraph', text: '官方今日正式公布夏目彩春年度巡回粉丝见面会计划，本次巡演共设东京、大阪、名古屋、福冈、札幌五个城市站点。' },
      { type: 'heading', text: '首站十月开启' },
      { type: 'paragraph', text: '首站活动将于十月在东京举行。届时除主舞台访谈外，还将设置作品回顾展区，展出夏目彩春历年经典造型与幕后花絮。' },
      { type: 'paragraph', text: '主办方表示，本次见面会将严格控制入场人数，以确保每位观众都能获得良好的参与体验。' },
      { type: 'heading', text: '购票信息' },
      { type: 'paragraph', text: '各站点门票将分批开售，具体时间与渠道请以官方后续公告为准。' },
    ],
  },
  {
    id: 'news-niguang-finale',
    title: '《逆光而行》圆满收官，现实主义题材再获口碑高峰',
    category: '作品更新',
    date: '2025-08-12',
    author: '编辑部',
    summary: '职场励志剧《逆光而行》正式收官，全剧豆瓣评分稳定在8.8，成为本年度现实主义题材的口碑之作。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20a%20confident%20asian%20businesswoman%20standing%20in%20a%20modern%20glass%20office%20at%20golden%20hour%2C%20strong%20warm%20backlight%2C%20deep%20navy%20and%20amber%20tones%2C%20editorial%20photography%2C%20film%20grain&width=800&height=560&seq=natsume-news-04&orientation=landscape',
    content: [
      { type: 'paragraph', text: '由田中惠美执导的职场励志剧《逆光而行》于本周正式收官，全剧评分稳定在8.8分，讨论度持续走高。' },
      { type: 'heading', text: '女性成长叙事引发共鸣' },
      { type: 'paragraph', text: '夏目彩春饰演的建筑师相马茜，在资源匮乏的困境中带领团队完成地标项目。剧中对职场现实的呈现被观众评价为「真实到窒息，却又充满希望」。' },
      { type: 'paragraph', text: '大结局中，相马茜的一段独白成为全网热传的金句，相关话题登上热搜。' },
      { type: 'heading', text: '幕后花絮' },
      { type: 'paragraph', text: '据剧组透露，为呈现专业场景，演员们曾进入真实建筑事务所实习两周。' },
    ],
  },
  {
    id: 'news-huashi-nomination',
    title: '《最后的画师》获年度最佳影片提名，夏目彩春演技跨度受赞誉',
    category: '新闻报道',
    date: '2025-07-20',
    author: '记者 林晓',
    summary: '传记电影《最后的画师》获得年度最佳影片等多项提名，夏目彩春横跨四十年的表演跨度成为最大亮点。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20an%20asian%20woman%20in%20a%20traditional%20art%20studio%20holding%20a%20painting%20brush%2C%20warm%20lantern%20light%20and%20deep%20indigo%20tones%2C%20paint%20splattered%20wooden%20desk%2C%20moody%20cinematic%20lighting%2C%20editorial%20photography%2C%20film%20grain&width=800&height=560&seq=natsume-news-05&orientation=landscape',
    content: [
      { type: 'paragraph', text: '年度电影奖项提名名单公布，传记电影《最后的画师》入围最佳影片、最佳导演、最佳女主角等六项提名。' },
      { type: 'heading', text: '四十年的时间跨度' },
      { type: 'paragraph', text: '夏目彩春在片中饰演日本画师绫子，角色年龄从二十岁跨越到六十岁。为呈现年龄变化，她通过体态、声线与眼神的细致调整完成过渡。' },
      { type: 'paragraph', text: '影评人评价称，这是她「迄今为止最有野心的一次表演」。' },
      { type: 'heading', text: '关于传统工艺' },
      { type: 'paragraph', text: '影片将传统装裱工艺作为核心线索，唤起公众对日渐失传技艺的关注。' },
    ],
  },
  {
    id: 'news-special-screening',
    title: '经典作品《雪国列车之夜》特别放映会举行，主创重聚分享幕后',
    category: '活动信息',
    date: '2025-06-18',
    author: '活动组',
    summary: '为纪念《雪国列车之夜》上映三周年，片方举办特别放映会，夏目彩春与导演高桥慎一同台分享拍摄经历。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20a%20cozy%20dim%20cinema%20auditorium%20with%20a%20lit%20screen%20and%20rows%20of%20empty%20seats%2C%20warm%20amber%20sconce%20lighting%20against%20deep%20charcoal%20shadows%2C%20moody%20atmospheric%20lighting%2C%20editorial%20photography%2C%20film%20grain&width=800&height=560&seq=natsume-news-06&orientation=landscape',
    content: [
      { type: 'paragraph', text: '为纪念电影《雪国列车之夜》上映三周年，片方于本月举办特别放映会，现场座无虚席。' },
      { type: 'heading', text: '主创重聚' },
      { type: 'paragraph', text: '放映结束后，夏目彩春与导演高桥慎一同台，回顾了当年在零下环境中拍摄的经历。' },
      { type: 'paragraph', text: '她提到，片中那段长达八分钟的车厢长镜头是全片最难的一场戏，「拍了整整两天，但很值得」。' },
      { type: 'heading', text: '观众反响' },
      { type: 'paragraph', text: '现场观众表示，时隔三年重看依然被影片的克制与温度打动。' },
    ],
  },
  {
    id: 'news-style-shoot',
    title: '夏目彩春登时尚杂志封面，首次公开谈表演方法论',
    category: '新闻报道',
    date: '2025-05-25',
    author: '记者 陈默',
    summary: '夏目彩春登上知名时尚杂志封面，在专访中首次系统谈及自己对角色的研究方法与职业规划。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20fashion%20editorial%20photograph%20of%20an%20elegant%20asian%20woman%20in%20a%20minimal%20cream%20studio%20with%20soft%20directional%20lighting%2C%20neutral%20warm%20beige%20and%20charcoal%20tones%2C%20high%20fashion%20magazine%20cover%20aesthetic%2C%20magazine%20photography%2C%20film%20grain&width=800&height=560&seq=natsume-news-07&orientation=landscape',
    content: [
      { type: 'paragraph', text: '夏目彩春受邀登上知名时尚杂志封面，并接受长篇专访。' },
      { type: 'heading', text: '谈角色研究' },
      { type: 'paragraph', text: '在专访中，她首次系统谈及自己的表演方法论：为每个角色建立独立的人物档案，包括成长经历、生活习惯甚至睡眠时间。' },
      { type: 'paragraph', text: '「我不太相信『演』这个字，我更愿意相信『成为』，」她说。' },
      { type: 'heading', text: '关于未来计划' },
      { type: 'paragraph', text: '谈及未来，她表示希望尝试更多元化的题材，包括舞台剧与国际合作项目。' },
    ],
  },
  {
    id: 'news-dongjing-renewal',
    title: '《东京迷途》确认开发第二季，原班人马有望回归',
    category: '作品更新',
    date: '2025-04-10',
    author: '编辑部',
    summary: '悬疑剧《东京迷途》正式确认开发第二季，编剧团队已进入剧本创作阶段，原班人马有望回归。',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20photograph%20of%20a%20rainy%20neon%20lit%20tokyo%20alley%20at%20night%20with%20wet%20reflective%20pavement%20and%20glowing%20signs%2C%20cold%20cyan%20and%20deep%20blue%20tones%20with%20a%20single%20warm%20street%20lamp%2C%20moody%20atmospheric%20lighting%2C%20editorial%20photography%2C%20film%20grain&width=800&height=560&seq=natsume-news-08&orientation=landscape',
    content: [
      { type: 'paragraph', text: '据官方消息，悬疑剧《东京迷途》已正式立项开发第二季，编剧团队进入剧本创作阶段。' },
      { type: 'heading', text: '故事延续' },
      { type: 'paragraph', text: '第二季将延续第一季结尾留下的悬念，刑警桐生凛的故事会进入全新阶段。' },
      { type: 'paragraph', text: '制作方表示，正在与包括夏目彩春在内的原班演员沟通档期。' },
      { type: 'heading', text: '预计开拍时间' },
      { type: 'paragraph', text: '若进展顺利，第二季预计将于明年上半年开拍。' },
    ],
  },
];

export const newsCategories = ['新闻报道', '活动信息', '作品更新'];